/* eslint-disable import/prefer-default-export */
import client from '../helpers/HttpClient';

export const bookConsignment = (id) =>
  client.post(`lib/bring/booking/${id}`, {});
